import request from '@/utils/request'

export function getUserInfo() {
  return request({
    url: '/mypage/userInfo',
    method: 'get',
    meta: { useAuth: true }
  })
}

export function setUserInfo(params) {
  return request({
    url: '/mypage/userInfo',
    method: 'POST',
    data: params,
    meta: { useAuth: true, useErrorMessage: false }
  })
}

export function getUserSites() {
  return request({
    url: '/mypage/userInfo/sites',
    method: 'get',
    meta: { useAuth: true }
  })
}

export function updateUserSites(gridSaveDatas) {
  let data = []
  if (gridSaveDatas.updated && gridSaveDatas.updated.length > 0) {
    data = gridSaveDatas.updated
  }
  return request({
    url: '/mypage/userInfo/sites',
    method: 'put',
    data,
    meta: { useAuth: true }
  })
}
